import React from 'react';
import VenuesTable from '../components/VenuesTable/index';

export default function Venues() {
  return <VenuesTable />;
}
